import React, { useEffect, useState } from "react";
import "../../../css/messages.css";
import ChatroomItem from "../parts/ChatroomItem";
import DeleteMessageModal from "../parts/DeleteMessageModal";
import {
  getChatrooms,
  deleteChatroomAPIEndpoint,
} from "../_redux/messageCrud";
import * as MessagesRedux from "../_redux/messageRedux";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";

function Chatrooms(props) {
  const history = useHistory();

  const Chatrooms = useSelector((state) => state.messages.chatrooms);
  const CurrentUser = useSelector((state) => state.auth.user);

  const [chatroomToDelete, setChatroomToDelete] = useState(null);

  useEffect(() => {
    handleChatroomFetch();

    const interval = setInterval(() => {
      handleChatroomFetch();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  function handleChatroomFetch() {
    getChatrooms()
      .then((res) => res.data)
      .then((data) => {
        props.setChatrooms({ chatrooms: data, currentUserId: CurrentUser._id });
      });
  }

  function handleDeleteChatroom() {
    deleteChatroomAPIEndpoint(chatroomToDelete._id)
      .then((res) => res.data)
      .then((data) => {
        props.removeChatroom(data);
        setChatroomToDelete(null);
        toast.success("Sohbet silindi");
      });
  }

  return (
    <div className="chat-panel">
      {chatroomToDelete ? (
        <DeleteMessageModal
          title="Sohbet Silinsin Mi?"
          closeModal={() => setChatroomToDelete(null)}
          deleteMessage={handleDeleteChatroom}
        />
      ) : null}

      <div className="chat-panel-header">
        <div className="chat-panel-header-icon">
          <i className="fa fa-comments" />
        </div>
        <div>
          <h3>Sohbetler</h3>
          <p>Tüm mesajlaşmalarınız tek yerde</p>
        </div>
      </div>

      <div className="chat-panel-body">
        {Chatrooms.length == 0 ? (
          <div className="chatrooms-empty">
            <i className="fa fa-comments-o" />
            <p>Henüz bir sohbetiniz yok</p>
          </div>
        ) : (
          Chatrooms.map((item) => {
            return (
              <ChatroomItem
                key={item._id}
                item={item}
                history={history}
                currentUserId={CurrentUser._id}
                activeId={props.activeId}
                onDelete={setChatroomToDelete}
              />
            );
          })
        )}
      </div>
    </div>
  );
}

export default connect(MessagesRedux.reducer, MessagesRedux.actions)(Chatrooms);
